//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/check_box'
import 'devextreme/ui/date_box'
import 'devextreme/ui/radio_group'
import 'devextreme/ui/text_area'

//#endregion

import { USER_SESSION_SERVICE_NAME } from "../../../../../services/user-session"
import { ALZ_ACTION_SERVICE_NAME } from './services'
import { REFERENCE_TYPE_SERVICE_NAME } from '../../../../../services/reference-type'
import { DATE_BOX_CONTROLS_SERVICE_NAME } from '../../../../../services/controls'
import { IMRBaseComponent } from "../../../base"
import { AlzActionController } from './action-run.dedicated.alz-action.controller'

export const COMPONENT_NAME: string = 'alzAction'

//#region Asset Imports

import './action-run.dedicated.alz-action.scss'
import * as TEMPLATE from './action-run.dedicated.alz-action.tpl.html'

//#endregion

export class AlzActionComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: AlzActionController,
            template: TEMPLATE,
            services: [USER_SESSION_SERVICE_NAME, ALZ_ACTION_SERVICE_NAME, REFERENCE_TYPE_SERVICE_NAME, DATE_BOX_CONTROLS_SERVICE_NAME]
        })
    }

}